export const siteInfo = {
  name: "爆料网",
  tagline: "最新吃瓜黑料曝光汇总，每日黑料合集·独家内幕",
  description: "聚合黑料网爆料、爆料黑料网等热门黑料，提供911爆料网吃瓜黑料实时更新，每日黑料合集与独家内幕曝光，满足吃瓜群众一次性获取黑料汇总的需求。",
  keywords: "黑料网爆料,爆料黑料网,吃瓜黑料,911爆料网吃瓜黑料,黑料合集,黑料曝光,黑料汇总,每日黑料,独家内幕,网红黑料",
  url: "https://www.baoliaowang.com",
  foundingYear: "2019",
  email: "contact@baoliaowang.com",
  phone: "400-888-6666",
  address: "北京市朝阳区传媒大道88号爆料大厦",
  socialLinks: {
    weibo: "https://weibo.com/baoliaowang",
    wechat: "baoliaowang666",
    douyin: "baoliaowang",
  },
};

export const aboutContent = {
  title: "关于爆料网",
  brandIntro: "爆料网成立于2019年，是国内领先的黑料聚合与娱乐八卦资讯平台。我们致力于为吃瓜群众提供最及时、最全面、最真实的爆料内容，汇聚全网热门黑料，打造一站式吃瓜体验。",
  mission: "我们的使命是打破信息壁垒，让每一个吃瓜群众都能第一时间获取最劲爆的内幕消息。我们坚持客观、公正的内容原则，为用户提供高质量的娱乐资讯服务。",
  reputation: `自上线以来，爆料网已累计服务超过5000万吃瓜用户，日均更新爆料内容200+条，与超过100家娱乐媒体建立内容合作关系。平台以“快、准、全”著称，在行业内享有极高声誉。`,
  teamDescription: "爆料网拥有一支专业的编辑团队和强大的技术支撑，全天候24小时监控全网热点，确保用户不错过任何一个劲爆大瓜。",
  contactIntro: "如有爆料线索、商务合作或内容侵权等问题，欢迎通过以下方式联系我们：",
  faqs: [
    {
      question: "爆料网的内容来源是什么？",
      answer: "爆料网的内容来源于合作的娱乐媒体、社交媒体公开信息、用户投稿线索以及专业编辑团队的深度挖掘，所有内容均经过严格核实后发布。",
    },
    {
      question: "如何向爆料网投稿爆料？",
      answer: "您可以通过网站底部的联系方式或发送邮件至 contact@baoliaowang.com 提交爆料线索。我们会对每一条线索进行核实，采用后将署名感谢。",
    },
    {
      question: "爆料网的内容是否真实可靠？",
      answer: "我们坚持\"核实后再发布\"的原则，每条内容都经过编辑团队的多方交叉验证。对于无法完全核实的信息，我们会标注\"仅供参考\"，确保用户知情权。",
    },
    {
      question: "爆料网更新频率如何？",
      answer: "爆料网实行7×24小时全天候更新机制，日均更新爆料内容200+条。重大事件发生15分钟内即有相关报道，确保用户第一时间吃到大瓜。",
    },
    {
      question: "如何申请删除涉及个人隐私的内容？",
      answer: "如您认为平台内容侵犯了您的合法权益，请发送邮件至 contact@baoliaowang.com 并附上相关证明材料，我们将在收到申请后48小时内核实处理。",
    },
  ],
};

export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-global-line", color: "bg-primary-500" },
  { id: "celebrity", name: "明星爆料", slug: "celebrity", icon: "ri-star-line", color: "bg-accent-500" },
  { id: "internet-celebrity", name: "网红黑料", slug: "internet-celebrity", icon: "ri-live-line", color: "bg-secondary-500" },
  { id: "entertainment", name: "娱乐圈", slug: "entertainment", icon: "ri-movie-2-line", color: "bg-accent-500" },
  { id: "social", name: "社会热点", slug: "social", icon: "ri-fire-line", color: "bg-primary-500" },
  { id: "business", name: "商业内幕", slug: "business", icon: "ri-briefcase-line", color: "bg-secondary-500" },
  { id: "politics", name: "政商秘闻", slug: "politics", icon: "ri-shield-line", color: "bg-primary-500" },
  { id: "tech", name: "科技圈", slug: "tech", icon: "ri-smartphone-line", color: "bg-accent-500" },
];